<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import OptionBox from '@/components/cloudCounter/OptionBox.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

const props = defineProps({
    headerText: String,
});



// const options = ref({
//     inputType: 'radio',  //radio/checkbox，default: 'checkbox'
//     inputValue: '',
//     inputName: 'time',
//     inputOptions: [
//         {
//             title: '113年8月2日',
//             optionValue: '2024-08-02',
//         },
//         {
//             title: '113年8月3日',
//             optionValue: '2024-08-03',
//         },
//     ],
// });

const goNextPage = () => {
    console.log('Go! Go! Go!');
}

const partTimeFormVisible = ref(false)

</script>

<template>

    <Layout :header="{ text: '要保人變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="1"></Process>
        </div>

        <h2 class="font-bold text-2xl pb-4">填寫新要保人資料</h2>
        <p class="pb-8">新要保人如非本公司有效保單之要保人，後續將郵寄 CRS/FATCA 相關文件，請新要保人填寫後回郵至本公司</p>

        <h3 class="text-xl font-bold pb-3">要保人基本資料</h3>

        <div class="mb-8">
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">姓名</h5>
                        <input type="text" placeholder="請填寫姓名" />
                    </li>
                    <li>
                        <h5 class="list__item__title">身分證字號</h5>
                        <input type="text" placeholder="請輸入身分證字號" />
                    </li>
                    <li>
                        <h5 class="list__item__title">國籍</h5>
                        <input type="text" value="中華民國" disabled />
                    </li>
                    <li>
                        <h5 class="list__item__title">出生日期</h5>
                        <input type="text" placeholder="請輸入出生日期" /><!-- 臨時 -->
                    </li>
                    <li>
                        <h5 class="list__item__title">與被保險人的關係</h5>
                        <input type="text" placeholder="請輸入與被保險人的關係" /><!-- 臨時 -->
                    </li>
                </ul>
            </CaseBox>
        </div>


        <h3 class="text-xl font-bold pb-3">要保人職業內容</h3>
        <div class="mb-8">
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">目前就職的公司名稱</h5>
                        <input type="text" name="" value="" placeholder="請填寫服務單位" />
                    </li>
                    <li>
                        <h5 class="list__item__title">公司行業類別</h5>
                        <input type="text" name="" value="" placeholder="請填寫公司行業類別" />
                    </li>
                    <li>
                        <h5 class="list__item__title">職位</h5>
                        <input type="text" name="" value="" placeholder="請填寫職位，如一般職員、企業負責人" />
                    </li>
                    <li>
                        <h5 class="list__item__title">職業代碼</h5>

                    </li>
                    <li>
                        <h5 class="list__item__title">工作內容</h5><input type="text" name="" value=""
                            placeholder="請填寫工作內容" />
                    </li>
                </ul>

                <button class="w-full mt-2 py-2 text-center text-[#0093C1]" @click="(e) => { partTimeFormVisible = true; }" v-if="!partTimeFormVisible">
                    <div class="inline-block align-text-bottom">
                        <svg fill="currentColor" style="width: 18px; height: 18px;" lns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <title>plus-circle</title>
                            <path
                                d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                    </div>
                    新增兼職內容
                </button>

                <template v-show="partTimeFormVisible">
                    <hr class="py-6">
                    <ul class="list">
                        <li>
                            <h5 class="list__item__title">兼職職業代碼 (非必填)</h5>
                            <input type="text" name="" value="" placeholder="請填寫兼職職業代碼" />
                        </li>
                        <li>
                            <h5 class="list__item__title">兼職工作內容 (非必填)</h5>
                            <input type="text" name="" value="" placeholder="請填寫工作內容" />
                        </li>
                    </ul>
                </template>

            </CaseBox>
        </div>

        <h3 class="text-xl font-bold pb-3">要保人聯絡資訊</h3>
        <div class="mb-8">
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">收費地址 (非必填)</h5>
                        <p class="text-sm pb-2">地址不可為郵政信箱</p>
                        <div class="flex pb-2">
                            <div class="w-1/2 pr-1">
                                <input type="text" name="" value="" placeholder="城市" /><!-- 臨時 -->
                            </div>
                            <div class="w-1/2 pl-1">
                                <input type="text" name="" value="" placeholder="區" /><!-- 臨時 -->
                            </div>
                        </div>
                        <input type="text" name="" value="" placeholder="地址" />
                    </li>
                    <li>
                        <h5 class="list__item__title">市話 (非必填)</h5>
                        <div class="flex">
                            <div class="w-1/3 pr-1">
                                <input type="text" name="" value="" placeholder="區碼" /><!-- 臨時 -->
                            </div>
                            <div class="w-2/3 pl-1">
                                <input type="text" name="" value="" placeholder="電話號碼" />
                            </div>
                        </div>
                    </li>
                </ul>

                <hr class="my-6">

                <div class="text-right pb-4">
                    <input class="pr-3 align-top" type="checkbox" /> 同收費地址
                </div>

                <ul class="list">
                    <li>
                        <h5 class="list__item__title">住所/戶籍地址 (非必填)</h5>
                        <p class="text-sm pb-2">地址不可為郵政信箱</p>
                        <div class="flex pb-2">
                            <div class="w-1/2 pr-1">
                                <input type="text" name="" value="" placeholder="城市" /><!-- 臨時 -->
                            </div>
                            <div class="w-1/2 pl-1">
                                <input type="text" name="" value="" placeholder="區" /><!-- 臨時 -->
                            </div>
                        </div>
                        <input type="text" name="" value="" placeholder="地址" />
                    </li>
                    <li>
                        <h5 class="list__item__title">市話 (非必填)</h5>
                        <div class="flex">
                            <div class="w-1/3 pr-1">
                                <input type="text" name="" value="" placeholder="區碼" /><!-- 臨時 -->
                            </div>
                            <div class="w-2/3 pl-1">
                                <input type="text" name="" value="" placeholder="電話號碼" />
                            </div>
                        </div>
                    </li>
                </ul>

                <hr class="my-6">

                <p class="text-sm pb-2">本次輸入之行動電話 / E-mail 將同時更新以新要保人於本公司投保之所有個人險有效及停效保單</p>

                <ul class="list">
                    <li>
                        <h5 class="list__item__title">行動電話</h5>
                        <input type="text" name="" value="" placeholder="請輸入行動電話" />
                    </li>
                    <li>
                        <h5 class="list__item__title">E-mail (非必填)</h5>
                        <input type="text" name="" value="" placeholder="請填寫E-mail" />
                    </li>
                </ul>
            </CaseBox>
        </div>

        <ul class="text-sm text-[#86878F] list-disc pl-6">
            <li>辦理要本人變更者，新要保人須無條件承受變更前本保單之權利義務，並請確認是否需一併變更要保人住所、收費地址。</li>
            <li>因辦理要保人變更事涉財產權益之移轉，本公司提醒您應依「遺產及贈與稅法」規定向國稅局辦理申報，以確保您的自身權益。</li>
        </ul>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="options?.inputValue == ''" @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped>

</style>
